/* istanbul ignore file */
import { makeMutation } from '@lib/mutation'
import {
  RegistrationResponse,
  RegistrationRequest,
  finishRegistration,
  RegistrationRequestBody,
} from '@plugins/Partners/GEB/api/registeration'

interface RegistrationLoader extends RegistrationRequest {
  body: RegistrationRequestBody
}

export const useFinishRegistration = makeMutation<RegistrationLoader, RegistrationResponse>({
  key: 'gigya-finish-registration',
  loader: async params => {
    const { body, ...reqParams } = params
    return await finishRegistration(reqParams, body)
  },
})
